import classNames from 'classnames/bind';
import { CONTENTTYPE_PERMISSIONS_MAP } from '@creditsights/api-ui-web';
import { Button, ButtonMode, ButtonSize, colors, Icon, ICONS } from '@creditsights/styleguide-web';
import React, { ReactElement } from 'react';
import { ContentTypeFilter, ContentTypeFilterToContentType } from '../../../../models';
import { CONTENT_TYPE_BUTTONS } from '../FeedLeftContainer.logic';
import styles from './ContentTabs.module.scss';

const cx = classNames.bind(styles);

interface ContentTabButtonProps {
  label: string;
  value: ContentTypeFilter;
}

interface ContentTabProps {
  articleType: ContentTypeFilter;
  setArticleType: (type: ContentTypeFilter) => void;
  permissions: string[];
}

export const ContentTabs = ({ articleType, setArticleType, permissions }: ContentTabProps): ReactElement => {
  const renderTabButton = ({ label, value }: ContentTabButtonProps) => {
    const contentType = ContentTypeFilterToContentType[value];
    const hasPermissions = permissions.includes(CONTENTTYPE_PERMISSIONS_MAP[contentType]);
    const icon = contentType && !hasPermissions ? ICONS.LockOutline : undefined;

    return (
      <Button
        className={cx('category-btn', { active: value === articleType })}
        onClick={() => setArticleType(value)}
        key={value}
        mode={ButtonMode.PRIMARY}
        size={ButtonSize.X_SMALL}
        ariaLabel={label}
      >
        {icon ? (
          <Icon
            name={ICONS.LockOutline}
            width={12}
            height={12}
            color={value === articleType ? colors['white-color'] : colors.tertiary700}
          />
        ) : undefined}
        {label}
      </Button>
    );
  };

  return <div className={cx('body')}>{CONTENT_TYPE_BUTTONS.map((button) => renderTabButton(button))}</div>;
};
